import script from "./BigIconFlexButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BigIconFlexButton.vue?vue&type=script&lang=ts&setup=true"

import "./BigIconFlexButton.vue?vue&type=style&index=0&id=77946c22&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77946c22"]])

export default __exports__